import React, { useCallback, useContext } from 'react'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import Group from 'components/utils/Group'
import FilterChip from 'LuxKit/Chips/FilterChip'
import { getCurrentDateLabel, getCurrentShortOccupancyLabel, getIsOccupancyMissingChildAges } from 'selectors/offerPage/offerPageSelectors'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import LineUsersAltIcon from 'LuxKit/Icons/line/LineUsersAltIcon'
import ModalContext from 'contexts/ModalContext'
import ModalBase from 'LuxKit/Modal/ModalBase'
import BedbankSidebarFilterCalendar from '../BedbankSidebarFilterCalendar'
import { getCapacitiesForBedbankOffer } from 'lib/offer/offerUtils'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import BedbankSidebarFilterCapacity from '../BedbankSidebarFilterCapacity'

interface Props {
  offer: App.BedbankOffer
  dateLabel: string
  occupancyLabel: string
  occupancyInvalid: boolean
}

function BedbankMobileStickyHeaderFilters({
  offer,
  dateLabel,
  occupancyLabel,
  occupancyInvalid,
}: Props) {
  const dispatch = useOfferPageDispatch()
  const showModal = useContext(ModalContext)

  const capacities = getCapacitiesForBedbankOffer(offer)

  const onClose = useCallback(() => {
    dispatch({ type: OfferPageActions.closeHeaderFilter })
  }, [dispatch])

  const onOpenCalendar = useCallback(() => {
    dispatch({ type: OfferPageActions.toggleHeaderFilter, filter: 'checkin' })

    showModal(<ModalBase mode="drawer"><BedbankSidebarFilterCalendar /></ModalBase>).then(onClose)
  }, [dispatch, showModal, onClose])

  const onOpenCapacity = useCallback(() => {
    dispatch({ type: OfferPageActions.toggleHeaderFilter, filter: 'capacity' })

    showModal(<ModalBase mode="drawer">
      <BedbankSidebarFilterCapacity capacities={capacities} />
    </ModalBase>).then(onClose)
  }, [dispatch, showModal, capacities, onClose])

  return (
    <Group direction="horizontal" gap={8}>
      <FilterChip
        startIcon={<LineCalendarIcon />}
        size="medium"
        onClick={onOpenCalendar}
        data-testid="OfferDatePickerSelectBox"
      >
        {dateLabel || 'Anytime'}
      </FilterChip>
      {occupancyLabel && <FilterChip
        startIcon={<LineUsersAltIcon />}
        size="medium"
        onClick={onOpenCapacity}
        error={occupancyInvalid}
      >
        {occupancyLabel}
      </FilterChip>}
    </Group>
  )
}

export default withOfferPageState((state) => ({
  offer: state.bedbankOffer!,
  dateLabel: getCurrentDateLabel(state),
  occupancyLabel: getCurrentShortOccupancyLabel(state),
  occupancyInvalid: getIsOccupancyMissingChildAges(state),
}), BedbankMobileStickyHeaderFilters)
